import React from 'react'
import styled from '@emotion/styled'

const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 0;
  &::after {
    content: '';
    flex: 0 0 32%;
  }
  li:nth-of-type(even) {
    border-right: 2px solid #000;
  }
`

const CardListTeam = props => {
  return <List>{props.children}</List>
}

export default CardListTeam
